@if (logsLoading) {
  <div class="state state-loading logs-loading">
    <mat-spinner diameter="24"></mat-spinner>
    <span>{{ 'DEAD_LETTERS.DETAIL.LOGS_LOADING' | translate }}</span>
  </div>
}

@if (!logsLoading && logsError) {
  <div class="state state-error logs-error">
    <mat-icon>error_outline</mat-icon>
    <span>{{ 'DEAD_LETTERS.DETAIL.ERRORS.LOGS_LOAD_FAILED' | translate }}</span>
  </div>
}

@if (!logsLoading && !logsError && logsEntries.length === 0) {
  <div class="logs-empty">
    {{ 'DEAD_LETTERS.DETAIL.VALUES.NO_LOGS' | translate }}
  </div>
}

@if (!logsLoading && !logsError && logsEntries.length > 0) {
  <div class="log-list">
    @for (entry of logsEntries; track entry) {
      <div class="log-entry">
        <!-- Line 1: time + severity + type -->
        <div class="log-line-1">
          @if (entry.timestamp) {
            <span class="log-timestamp">{{ entry.timestamp | date:'medium' }}</span>
          }
          @if (entry.type) {
            <span class="log-type">{{ entry.type }}</span>
          }
        </div>
        <!-- Line 2: message -->
        <div class="log-line-2">{{ entry.message }}</div>
        <!-- Line 3: detail messages with expandable stack traces -->
        @if (entry.details && entry.details.length > 0) {
          <div class="log-line-3">
            @for (d of entry.details; track d) {
              <div class="log-detail-row">
                <div class="log-detail-message">{{ d.message }}</div>
                @if (d.stackTrace && d.stackTrace.length > 0) {
                  <details class="log-stack-trace">
                    <summary>{{ 'DEAD_LETTERS.DETAIL.SECTIONS.STACK_TRACE' | translate }}</summary>
                    <pre class="stack-trace-content">{{ d.stackTrace.join('\n') }}</pre>
                  </details>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
}
